

export const About = () => {
    return (
        <section className="agency_section layout_padding2-top">
            <div className="agency_container">
                <div className="box ">
                    <div className="detail-box">
                        <div className="heading_container">
                            <h2>
                                За <span style={{color: '#0074D9'}}>QPro </span>Engineering
                            </h2>
                        </div>
                        <p>
                            QPro Engineering e млада фирма с богат опит, която е съсредоточена в изготвяне на конструктивни решения за Вашия бъдещ проект. <br /> Ако имате интерес към нашата дейност или какъв е нашият стил на проектиране се свържете с нас, за да ви изпратим примерни конструктивни решения, за да прецените дали може да ни се доверите. 
                        </p>
                    
                    </div>
                </div>
            </div>
        </section>

    )
}